import ReactDOM from "react-dom/client";
import { HashRouter as Router, Routes, Route } from "react-router-dom"
import { AuthProvider } from "./contexts/AuthContext"
import { WalletProvider } from "./contexts/WalletContext"
import Navbar from "./components/Navbar"
import LandingPage from "./pages/LandingPage"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Dashboard from "./pages/Dashboard"
import BuyData from "./pages/BuyData"
import BuyAirtime from "./pages/BuyAirtime"
import PayBills from "./pages/PayBills"
import Transactions from "./pages/Transactions"
import Wallet from "./pages/Wallet"
import Profile from "./pages/Profile"
import AirtimeToCash from "./pages/AirtimeToCash"
import { Toaster } from "react-hot-toast"
import "./index.css"

function App() {
  return (
    <AuthProvider>
      <WalletProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Navbar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/buy-data" element={<BuyData />} />
              <Route path="/buy-airtime" element={<BuyAirtime />} />
              <Route path="/pay-bills" element={<PayBills />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/airtime-to-cash" element={<AirtimeToCash />} />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </WalletProvider>
    </AuthProvider>
  )
}

export default App

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
